<template>
  <div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>Provincia</h3>
			</div>
		</div>
		<div class="layout__main">
			<div class="layout__main-form">
				<div class="card">
					<div class="card__content">
						<div class="row">
							<div class="col-xs-12 col-md-6">
								<input-field v-model="form.provincia_id" id="pais_id" placeholder="Código de la provincia...">
									Código
									<span v-if="errores.provincia_id" class="helper-text text-danger" slot="helper">
										<strong>{{ errores.provincia_id[0] }}</strong>
									</span>
								</input-field>
							</div>
							<div class="col-xs-12 col-md-6">
								<input-field v-model="form.descripcion" id="descripcion" placeholder="Nombre de la provincia/estado...">
									Nombre
									<span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
										<strong>{{ errores.descripcion[0] }}</strong>
									</span>
								</input-field>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="layout__main-buttons">
				<div class="card">
					<div class="card__content">
						<button @click="botonGuardar" class="btn-success"><i class="fa fa-save"></i><span>Guardar</span></button>
						<button @click="botonLimpiar" class="btn-primary btn--text"><i class="fa fa-refresh"></i><span>Limpiar</span></button>
						<button @click="botonCerrar" class="btn-danger"><i class="fa fa-times-circle"></i><span>Cerrar</span></button>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>
<script>
export default {
	props: {
		propProvincia: {
			type: Object,
			required: false,
			default: function(){
				return null;
			}
		},
		paisId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			provincia: this.propProvincia,
			form: {
				provincia_id: '',
				pais_id: this.paisId,
				descripcion: '',
			},
			errores: {}
		}
	},
	mounted() {
		if(this.provincia != null){
			this.form.provincia_id = this.provincia.id_provincia;
			this.form.pais_id = this.provincia.id_pais;
			this.form.descripcion = this.provincia.descripcion;
		}
	},
	methods: {
		limpiarErrores: function(){
			this.errores = {};
		},
		limpiar: function(){
			this.form.provincia_id = '';
			this.form.pais_id = this.paisId;
			this.form.descripcion = '';
			this.provincia = null;
			this.limpiarErrores();
		},
		botonLimpiar: function(){
			swal.fire({
				title: '¿Desea limpiar los campos?',
				text: "Esta acción requiere de confirmación.",
				type: 'question',
				showCancelButton: true,
				confirmButtonText:'Aceptar'
				}).then((result) => {
					if (result.value) {
						this.limpiar();
					}
				});
		},
		botonGuardar: function(){
			swal.fire({
				title: '¿Deseas guardar la Provincia/Estado?',
				text: "Esta acción requiere de confirmación.",
				type: 'question',
				showCancelButton: true,
				confirmButtonText:'Aceptar'
		}).then((result) => {
				if (result.value) {
					let urlApi = '';
					if(this.provincia != null)
						urlApi = url+ '/zona-geografica/editar-provincia';
					else
						urlApi = url+ '/zona-geografica/guardar-provincia';
					axios.post(urlApi, this.form).then(response => {
						let data = response.data;
						this.limpiarErrores();
						swal.fire('Almacenado', 'Se ha almacenado satisfactoriamente.', 'success');
						this.$emit('cargarProvincia', data.provincia);
						this.$modal.hide('provincia');
					}).catch(error => {
						if (error !== undefined && error !== null) {
							let response = error.response;
							if (response !== undefined && response !== null) {
								let status = response.status;
								if (status === 422) {
									this.errores = response.data.errors;
									swal.fire("Hay validaciones por corregir.", "Aviso", "warning");
								} else{
										if(response.data.message != null && response.data.message != '')
											swal.fire('Error', response.data.message, 'error');
										else
											swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
									}
							}
						}
					});
				}
			});
		},
		botonCerrar: function(){
			this.$modal.hide('provincia');
		},
	},
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/zona-geografica/Provincia.vue